import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Button } from '@/components/ui/button';

export default function ResumeViewerPopup({ isOpen, onClose, resumeUrl, resumeFileName }) {
    return (
        <Dialog open={isOpen} onClose={onClose} className="fixed z-50 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen px-4">
                <div className="fixed inset-0 bg-black opacity-30" onClick={onClose} />

                <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden max-w-4xl w-full mx-auto my-8 transition-all flex flex-col">
                    {/* Close Button */}
                    <button
                        className="absolute top-4 right-4 text-gray-400 hover:bg-gray-100 p-2 rounded-full transition"
                        onClick={onClose}
                    >
                        <XMarkIcon className="h-5 w-5" />
                    </button>

                    {/* Content */}
                    <div className="flex flex-col items-center flex-grow p-6">
                        <h3 className="text-2xl font-bold mb-4 text-gray-800">
                          Resume Preview - {resumeFileName?.split('_').slice(1).join('_')}
                        </h3>

                        {resumeUrl ? (
                            <iframe
                                src={resumeUrl}
                                className="w-full h-[700px] rounded-lg border"
                                title="Resume PDF"
                            />
                        ) : (
                            <div className="flex items-center justify-center h-64">
                                <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500"></div>
                            </div>
                        )}
                    </div>

                    {/* Button outside of p-6 */}
                    <div className="px-6 pb-6 w-full">
                        <Button
                            className="bg-blue-600 hover:bg-blue-700 w-full h-12 text-white text-sm font-medium rounded-lg"
                            onClick={onClose}
                        >
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}